

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchAllTaskTracking,
//   updateTaskTrackingRemarks,
// } from "../redux/actions/taskTrackingActions";
// import {
//   fetchDistricts,
//   fetchMunicipalities,
// } from "../redux/actions/locationActions";
// import { fetchDesignations } from "../redux/actions/designationActions";

// import { FiSearch, FiDownload, FiEdit3, FiCheck } from "react-icons/fi";
// import Papa from "papaparse";
// import theme from "../components/shared/theme";
// import {
//   thStyle,
//   tdStyle,
//   paginationButtonStyle,
//   dropdownStyle,
// } from "../components/shared/themeStyles";

// const formatIndianDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };

// const TaskTracking = () => {
//   const dispatch = useDispatch();
//   const { taskTrackingData, loading, error, meta = {} } = useSelector((state) => state.taskTracking);
//   const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});
//   const { designations = [] } = useSelector((state) => state.designation || {});

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedMunicipality, setSelectedMunicipality] = useState("");
//   const [selectedDesignation, setSelectedDesignation] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [editingId, setEditingId] = useState(null);
//   const [updatedRemark, setUpdatedRemark] = useState("");
//   const [statusDropdown, setStatusDropdown] = useState("ongoing");
//   const [mapModalOpen, setMapModalOpen] = useState(false);
//   const [mapAddress, setMapAddress] = useState("");
//   const [mapLoading, setMapLoading] = useState(false);

//   const totalPages = meta?.totalPages || 1;

//   const API_KEY = process.env.REACT_APP_MAP_API_KEY;

//   useEffect(() => {
//     fetchData();
//     dispatch(fetchDistricts());
//     dispatch(fetchMunicipalities());
//     dispatch(fetchDesignations());
//   }, [
//     dispatch,
//     currentPage,
//     selectedDistrict,
//     selectedMunicipality,
//     selectedDesignation,
//     searchTerm,
//     fromDate,
//     toDate,
//     statusDropdown,
//   ]);

//   const fetchData = () => {
//     const query = {
//       page: currentPage,
//       limit: itemsPerPage,
//       district: selectedDistrict,
//       municipality: selectedMunicipality,
//       search: searchTerm,
//       fromDate,
//       toDate,
//       status: statusDropdown,
//       designation: selectedDesignation,
//     };
//     dispatch(fetchAllTaskTracking(query));
//   };

//   const fetchAddress = async (lat, lng) => {
//     try {
//       setMapLoading(true);
//       const res = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
//       );
//       const data = await res.json();
//       setMapAddress(
//         data.status === "OK"
//           ? data.results[0]?.formatted_address || "Address not found"
//           : "Unable to fetch address"
//       );
//     } catch (e) {
//       setMapAddress("Error fetching address");
//     } finally {
//       setMapLoading(false);
//     }
//   };

//   const handleViewMap = async (lat, lng) => {
//     if (!lat || !lng) return;
//     setMapModalOpen(true);
//     await fetchAddress(lat, lng);
//   };

//   const closeMapModal = () => {
//     setMapModalOpen(false);
//     setMapAddress("");
//   };

//   const resetFilters = () => {
//     setSelectedDistrict("");
//     setSelectedMunicipality("");
//     setSelectedDesignation("");
//     setSearchTerm("");
//     setFromDate("");
//     setToDate("");
//     setStatusDropdown("");
//     setCurrentPage(1);
//   };

//   const handleExportCSV = () => {
//     const exportData = taskTrackingData.map((item) => ({
//       District: item.district_name || "-",
//       Municipality: item.municipality_name || "-",
//       Task: item.task_name || "-",
//       User: item.user_name || "-",
//       Phone: item.user_phone || "-",
//        designation: item.designation || "-",
//       "Check In": item.start_time || "-",
//       "Check Out": item.end_time || "-",
//       "Start Lat-Long": `${item.start_latitude || "-"}, ${item.start_longitude || "-"}`,
//       "End Lat-Long": `${item.end_latitude || "-"}, ${item.end_longitude || "-"}`,
//       Date: formatIndianDate(item.created_at),
//       Remarks: item.task_tracking_remarks || "-",
//       Status: item.status || "-",
//     }));

//     const csv = Papa.unparse(exportData);
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", "Task_Tracking_Report.csv");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleSaveRemarks = (id) => {
//     if (!updatedRemark.trim()) return;
//     dispatch(updateTaskTrackingRemarks(id, updatedRemark));
//     setEditingId(null);
//     setUpdatedRemark("");
//   };

//   return (
//     <>
//       <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md }}>
//         <div className="flex justify-between items-center mb-4">
//           <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold }}>
//             Task Tracking
//           </h1>
//         </div>

//         <div className="flex flex-wrap gap-3 items-center bg-white p-4 rounded-lg shadow mb-6">
//           <select value={selectedDistrict} onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
//             <option value="">All Districts</option>
//             {districts.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
//           </select>

//           <select value={selectedMunicipality} onChange={(e) => { setSelectedMunicipality(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
//             <option value="">All Municipalities</option>
//             {municipalities.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
//           </select>

//           <select value={selectedDesignation} onChange={(e) => { setSelectedDesignation(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
//             <option value="">All Designations</option>
//             {designations.map((d, i) => (
//               <option key={i} value={d}>{d}</option>
//             ))}
//           </select>

//           <select value={statusDropdown} onChange={(e) => { setStatusDropdown(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
//             <option value="">All Status</option>
//             <option value="ongoing">Ongoing</option>
//             <option value="complete">Complete</option>
//           </select>

//           <div className="relative w-full sm:w-[250px]">
//             <FiSearch className="absolute left-3 top-3 text-gray-500" />
//             <input
//               type="text"
//               placeholder="Search name, phone, task"
//               value={searchTerm}
//               onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//               style={{ ...dropdownStyle, paddingLeft: theme.spacing.lg }}
//             />
//           </div>

//           <input type="date" value={fromDate} onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }} style={dropdownStyle} />
//           <input type="date" value={toDate} onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }} style={dropdownStyle} />

//           <button onClick={resetFilters} style={{ backgroundColor: theme.colors.primary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md, fontWeight: theme.font.weight.medium }}>Reset</button>
//           <button onClick={handleExportCSV} style={{ backgroundColor: theme.colors.secondary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md, fontWeight: theme.font.weight.medium, display: "flex", alignItems: "center", gap: "0.5rem" }}>
//             <FiDownload /> Export CSV
//           </button>
//         </div>

//         {loading ? (
//           <p>Loading...</p>
//         ) : error ? (
//           <p className="text-red-600">Error: {error}</p>
//         ) : (
//           <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//             <table className="min-w-[1400px] w-full text-sm text-left">
//               <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
//                 <tr>
//                   <th style={thStyle}>#</th>
//                   <th style={thStyle}>Task</th>
//                   <th style={thStyle}>User</th>
//                   <th style={thStyle}>Phone</th>
//                   <th style={thStyle}>Designation</th>
//                   <th style={thStyle}>District</th>
//                   <th style={thStyle}>Municipality</th>
//                   <th style={thStyle}>Check-In - Check-Out Time</th>
//                   <th style={thStyle}>Address (Start / End)</th>
//                   <th style={thStyle}>Date</th>
//                   <th style={thStyle}>Status</th>
//                   <th style={thStyle}>Remarks</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {taskTrackingData.map((item, index) => (
//                   <tr key={item.id || index} className="hover:bg-gray-50">
//                     <td style={tdStyle}>{(meta?.currentPage - 1) * itemsPerPage + index + 1}</td>
//                     <td style={tdStyle}>{item.task_name || "-"}</td>
//                     <td style={tdStyle}>{item.user_name || "-"}</td>
//                     <td style={tdStyle}>{item.user_phone || "-"}</td>
//                     <td style={tdStyle}>{item.designation || "-"}</td>
//                     <td style={tdStyle}>{item.district_name || "-"}</td>
//                     <td style={tdStyle}>{item.municipality_name || "-"}</td>
//                     <td style={tdStyle}>{(item.start_time || "-") + " - " + (item.end_time || "-")}</td>
//                     <td style={tdStyle}>
//                       <div>
//                         <strong>Start:</strong>{" "}
//                         {item.start_latitude && item.start_longitude ? (
//                           <button onClick={() => handleViewMap(item.start_latitude, item.start_longitude)} style={{ color: theme.colors.primary, textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>View Address</button>
//                         ) : "-"}
//                       </div>
//                       <div>
//                         <strong>End:</strong>{" "}
//                         {item.end_latitude && item.end_longitude ? (
//                           <button onClick={() => handleViewMap(item.end_latitude, item.end_longitude)} style={{ color: theme.colors.primary, textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>View Address</button>
//                         ) : "-"}
//                       </div>
//                     </td>
//                     <td style={tdStyle}>{formatIndianDate(item.created_at)}</td>
//                     <td style={tdStyle}>{item.status || "-"}</td>
//                     <td style={tdStyle}>
//                       {editingId === item.id ? (
//                         <div className="flex items-center gap-2">
//                           <select value={updatedRemark} onChange={(e) => setUpdatedRemark(e.target.value)} className="border px-2 py-1 text-xs rounded">
//                             <option value="">Select</option>
//                             <option value="inside">Inside</option>
//                             <option value="end_daily_task">Outside</option>
//                           </select>
//                           <button onClick={() => handleSaveRemarks(item.id)} className="text-green-600">
//                             <FiCheck />
//                           </button>
//                         </div>
//                       ) : (
//                         <div className="flex items-center justify-between gap-2">
//                           <span>{item.task_tracking_remarks || "-"}</span>
//                           <button onClick={() => {
//                             setEditingId(item.id);
//                             setUpdatedRemark(item.task_tracking_remarks || "");
//                           }}>
//                             <FiEdit3 className="text-gray-600" />
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div className="flex justify-between items-center p-4 border-t">
//               <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={paginationButtonStyle}>
//                 Previous
//               </button>
//               <p className="text-sm">Page {currentPage} of {totalPages}</p>
//               <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={paginationButtonStyle}>
//                 Next
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {mapModalOpen && (
//         <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
//           <div style={{ backgroundColor: "#fff", padding: theme.spacing.lg, borderRadius: theme.radius.xl, boxShadow: theme.shadow.xl, position: "relative", maxWidth: "500px", width: "100%" }}>
//             <button onClick={closeMapModal} style={{ position: "absolute", top: theme.spacing.sm, right: theme.spacing.sm, background: "none", border: "none", fontSize: "1.25rem", cursor: "pointer", color: theme.colors.grayDark }}>
//               ✖
//             </button>
//             <p style={{ fontSize: theme.font.size.base, color: theme.colors.grayDark }}>
//               {mapLoading ? "Fetching address..." : mapAddress}
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default TaskTracking;




import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllTaskTracking,
  updateTaskTrackingRemarks,
} from "../redux/actions/taskTrackingActions";
import {
  fetchDistricts,
  fetchMunicipalities,
} from "../redux/actions/locationActions";
import { fetchDesignations } from "../redux/actions/designationActions";

import { FiSearch, FiDownload, FiEdit3, FiCheck } from "react-icons/fi";
import Papa from "papaparse";
import theme from "../components/shared/theme";
import {
  thStyle,
  tdStyle,
  paginationButtonStyle,
  dropdownStyle,
} from "../components/shared/themeStyles";

// const formatIndianDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };
const formatIndianDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);

  // Convert to IST
  const offset = date.getTimezoneOffset() * 60000;
  const istDate = new Date(date.getTime() - offset);

  const day = String(istDate.getDate()).padStart(2, "0");
  const month = String(istDate.getMonth() + 1).padStart(2, "0");
  const year = istDate.getFullYear();

  let hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, "0");
  const seconds = String(istDate.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 -> 12 for midnight
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};

const TaskTracking = () => {
  const dispatch = useDispatch();
  const { taskTrackingData, loading, error, meta = {} } = useSelector((state) => state.taskTracking);
  const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});
  const { designations = [] } = useSelector((state) => state.designation || {});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [updatedRemark, setUpdatedRemark] = useState("");
  const [statusDropdown, setStatusDropdown] = useState("ongoing");
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [mapAddress, setMapAddress] = useState("");
  const [mapLoading, setMapLoading] = useState(false);

  const totalPages = meta?.totalPages || 1;

  const API_KEY = process.env.REACT_APP_MAP_API_KEY;

  useEffect(() => {
    fetchData();
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
    dispatch(fetchDesignations());
  }, [
    dispatch,
    currentPage,
    selectedDistrict,
    selectedMunicipality,
    selectedDesignation,
    searchTerm,
    fromDate,
    toDate,
    statusDropdown,
  ]);

  const fetchData = () => {
    const query = {
      page: currentPage,
      limit: itemsPerPage,
      district: selectedDistrict,
      municipality: selectedMunicipality,
      search: searchTerm,
      fromDate,
      toDate,
      status: statusDropdown,
      designation: selectedDesignation,
    };
    dispatch(fetchAllTaskTracking(query));
  };

  const fetchAddress = async (lat, lng) => {
    try {
      setMapLoading(true);
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
      );
      const data = await res.json();
      setMapAddress(
        data.status === "OK"
          ? data.results[0]?.formatted_address || "Address not found"
          : "Unable to fetch address"
      );
    } catch (e) {
      setMapAddress("Error fetching address");
    } finally {
      setMapLoading(false);
    }
  };

  const handleViewMap = async (lat, lng) => {
    if (!lat || !lng) return;
    setMapModalOpen(true);
    await fetchAddress(lat, lng);
  };

  const closeMapModal = () => {
    setMapModalOpen(false);
    setMapAddress("");
  };

  const resetFilters = () => {
    setSelectedDistrict("");
    setSelectedMunicipality("");
    setSelectedDesignation("");
    setSearchTerm("");
    setFromDate("");
    setToDate("");
    setStatusDropdown("");
    setCurrentPage(1);
  };

   const selectedDistrictObj = districts.find(d => d.name === selectedDistrict);
  const selectedDistrictId = selectedDistrictObj?.id;
  
  const filteredMunicipalities = selectedDistrictId
    ? municipalities.filter(m => m.district_id === selectedDistrictId)
    : municipalities;
  
  useEffect(() => {
    setSelectedMunicipality("");
  }, [selectedDistrict]);
  

  const handleExportCSV = () => {
    const exportData = taskTrackingData.map((item) => ({
      District: item.district_name || "-",
      Municipality: item.municipality_name || "-",
      Task: item.task_name || "-",
      User: item.user_name || "-",
      Phone: item.user_phone || "-",
       designation: item.designation || "-",
      "Check In": item.start_time || "-",
      "Check Out": item.end_time || "-",
      "Start Lat-Long": `${item.start_latitude || "-"}, ${item.start_longitude || "-"}`,
      "End Lat-Long": `${item.end_latitude || "-"}, ${item.end_longitude || "-"}`,
      Date: formatIndianDate(item.created_at),
      Remarks: item.task_tracking_remarks || "-",
      Status: item.status || "-",
       EndorsedBy: item.admin_username || "-",
        EndorsedTime: item.status_updated_at || "-",
    }));

    const csv = Papa.unparse(exportData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Task_Tracking_Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSaveRemarks = (id) => {
    if (!updatedRemark.trim()) return;
    dispatch(updateTaskTrackingRemarks(id, updatedRemark));
    setEditingId(null);
    setUpdatedRemark("");
  };

  return (
    <>
      <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md }}>
        <div className="flex justify-between items-center mb-4">
          <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold }}>
            Task Tracking
          </h1>
        </div>

        <div className="flex flex-wrap gap-3 items-center bg-white p-4 rounded-lg shadow mb-6">
          {/* <select value={selectedDistrict} onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
            <option value="">All Districts</option>
            {districts.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select> */}
          <select value={selectedDistrict} onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
                    <option value="">All Districts</option>
                    {districts?.map((d) => <option key={d.id || d.name} value={d.name}>{d.name}</option>)}
                  </select>

          {/* <select value={selectedMunicipality} onChange={(e) => { setSelectedMunicipality(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
            <option value="">All Municipalities</option>
            {municipalities.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select> */}
          <select
            value={selectedMunicipality}
            onChange={(e) => {
              setSelectedMunicipality(e.target.value);
              setCurrentPage(1);
            }}
            style={dropdownStyle}
          >
            <option value="">All Municipalities</option>
            {filteredMunicipalities.map((m) => (
              <option key={m.id} value={m.name}>
                {m.name}
              </option>
            ))}
          </select>

          <select value={selectedDesignation} onChange={(e) => { setSelectedDesignation(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
            <option value="">All Designations</option>
            {designations.map((d, i) => (
              <option key={i} value={d}>{d}</option>
            ))}
          </select>

          <select value={statusDropdown} onChange={(e) => { setStatusDropdown(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
            <option value="">All Status</option>
            <option value="ongoing">Ongoing</option>
            <option value="complete">Complete</option>
          </select>

          <div className="relative w-full sm:w-[250px]">
            <FiSearch className="absolute left-3 top-3 text-gray-500" />
            <input
              type="text"
              placeholder="Search name, phone, task"
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              style={{ ...dropdownStyle, paddingLeft: theme.spacing.lg }}
            />
          </div>

          <input type="date" value={fromDate} onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }} style={dropdownStyle} />
          <input type="date" value={toDate} onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }} style={dropdownStyle} />

          <button onClick={resetFilters} style={{ backgroundColor: theme.colors.primary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md, fontWeight: theme.font.weight.medium }}>Reset</button>
          <button onClick={handleExportCSV} style={{ backgroundColor: theme.colors.secondary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md, fontWeight: theme.font.weight.medium, display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FiDownload /> Export CSV
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-600">Error: {error}</p>
        ) : (
          <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
            <table className="min-w-[1400px] w-full text-sm text-left">
              <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
                <tr>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>Task</th>
                  <th style={thStyle}>User</th>
                  <th style={thStyle}>Phone</th>
                  <th style={thStyle}>Designation</th>
                  <th style={thStyle}>District</th>
                  <th style={thStyle}>Municipality</th>
                  <th style={thStyle}>Check-In - Check-Out Time</th>
                  <th style={thStyle}>Address (Start / End)</th>
                  <th style={thStyle}>Date</th>
                  <th style={thStyle}>Status</th>
                  <th style={thStyle}>Remarks</th>
                   <th style={thStyle}>Endorsed By</th>
                  <th style={thStyle}>Endorsed time</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {taskTrackingData.map((item, index) => (
                  <tr key={item.id || index} className="hover:bg-gray-50">
                    <td style={tdStyle}>{(meta?.currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td style={tdStyle}>{item.task_name || "-"}</td>
                    <td style={tdStyle}>{item.user_name || "-"}</td>
                    <td style={tdStyle}>{item.user_phone || "-"}</td>
                    <td style={tdStyle}>{item.designation || "-"}</td>
                    <td style={tdStyle}>{item.district_name || "-"}</td>
                    <td style={tdStyle}>{item.municipality_name || "-"}</td>
                    <td style={tdStyle}>{(item.start_time || "-") + " - " + (item.end_time || "-")}</td>
                    <td style={tdStyle}>
                      <div>
                        <strong>Start:</strong>{" "}
                        {item.start_latitude && item.start_longitude ? (
                          <button onClick={() => handleViewMap(item.start_latitude, item.start_longitude)} style={{ color: theme.colors.primary, textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>View Address</button>
                        ) : "-"}
                      </div>
                      <div>
                        <strong>End:</strong>{" "}
                        {item.end_latitude && item.end_longitude ? (
                          <button onClick={() => handleViewMap(item.end_latitude, item.end_longitude)} style={{ color: theme.colors.primary, textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>View Address</button>
                        ) : "-"}
                      </div>
                    </td>
                    <td style={tdStyle}>{formatIndianDate(item.created_at)}</td>
                    <td style={tdStyle}>{item.status || "-"}</td>
                    <td style={tdStyle}>
                      {editingId === item.id ? (
                        <div className="flex items-center gap-2">
                          <select value={updatedRemark} onChange={(e) => setUpdatedRemark(e.target.value)} className="border px-2 py-1 text-xs rounded">
                            <option value="">Select</option>
                            <option value="inside">Inside</option>
                            <option value="end_daily_task">Outside</option>
                          </select>
                          <button onClick={() => handleSaveRemarks(item.id)} className="text-green-600">
                            <FiCheck />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center justify-between gap-2">
                          <span>{item.task_tracking_remarks || "-"}</span>
                          <button onClick={() => {
                            setEditingId(item.id);
                            setUpdatedRemark(item.task_tracking_remarks || "");
                          }}>
                            <FiEdit3 className="text-gray-600" />
                          </button>
                        </div>
                      )}
                    </td>
                    
 <td style={tdStyle}>{item.admin_username || "-"}</td>
                   <td style={tdStyle}>{formatIndianDate(item.status_updated_at) || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-between items-center p-4 border-t">
              <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={paginationButtonStyle}>
                Previous
              </button>
              <p className="text-sm">Page {currentPage} of {totalPages}</p>
              <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={paginationButtonStyle}>
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {mapModalOpen && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
          <div style={{ backgroundColor: "#fff", padding: theme.spacing.lg, borderRadius: theme.radius.xl, boxShadow: theme.shadow.xl, position: "relative", maxWidth: "500px", width: "100%" }}>
            <button onClick={closeMapModal} style={{ position: "absolute", top: theme.spacing.sm, right: theme.spacing.sm, background: "none", border: "none", fontSize: "1.25rem", cursor: "pointer", color: theme.colors.grayDark }}>
              ✖
            </button>
            <p style={{ fontSize: theme.font.size.base, color: theme.colors.grayDark }}>
              {mapLoading ? "Fetching address..." : mapAddress}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TaskTracking;
